import type { FieldProp } from 'react-typed-form';

import * as React from 'react';

import FieldText from './FieldText';

export type Props = Readonly<
  {
    field: FieldProp<string>;
  } & Omit<React.ComponentProps<typeof FieldText>, 'field'>
>;

export default function FieldTextRequired({ field, ...rest }: Props) {
  // FieldText takes FieldProp<string | null>; required narrows it to string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return <FieldText field={field as any} required {...rest} />;
}
